import { useFeatureFlagEnabled } from 'posthog-js/react';

export type BooleanFeatureFlag =
  | 'enable-live-code'
  | 'enable-endpoints'
  | 'enable-function-flowchart'
  | 'enable-pr-comparisons-page'
  | 'enable-kafka-topics'
  | 'enable-entry-function'
  | 'enable-1-hour-timeframe'
  | 'enable-time-timepicker'
  | 'enable-jb-in-ide-selector'
  | 'enable-mcp-sidebar-card'
  | 'show-extension-banner'
  | 'show-source-map-keys'
  | 'show-exemplars'
  | 'enable-overview-page'
  | 'show-deployments'
  | 'show-issues-in-charts'
  | 'enable-slack-integration';

export function useBooleanFeatureFlag(
  flag: BooleanFeatureFlag,
  fallback?: boolean,
): boolean {
  return useFeatureFlagEnabled(flag) ?? fallback ?? false;
}
